<div class="wrapper">
  <div class="main-panel">
    <pp-header></pp-header>
    <ng-container>
      <app-modal-container></app-modal-container>
      <mat-sidenav-container>
        <mat-sidenav mode="side" class="workitem-sidebar" [opened]="isSidebarOpen$ | async">
          <app-workorders-tab></app-workorders-tab>
        </mat-sidenav>

        <mat-sidenav-content id="app-content">
          <main class="h-100">
            <router-outlet></router-outlet>
          </main>
        </mat-sidenav-content>
      </mat-sidenav-container>
    </ng-container>
  </div>
</div>
